import { SUPPORTED_LOCALES } from '../../../i18n/locales';
import { ApiCallConfig, apiCall } from '../../../utils/apiCall';

import { blogApiCall } from './utils/blogApiCall';
import {
  APIBlogResponse,
  BlogArticle,
  BlogArticleMetadata,
} from './blog.types';

export const getBlogArticles = async (
  locale = SUPPORTED_LOCALES.EN,
  limit = 100
) =>
  blogApiCall({
    endpoint: `articles?sort[0]=createdAt%3Adesc&locale=${locale}&populate=category,author,image&fields=title,description,slug,createdAt&pagination[pageSize]=${limit}`,
    method: 'GET',
    reshaper: (
      data: APIBlogResponse<{ id: number; attributes: BlogArticle }>
    ) => data.data.map((entry) => entry.attributes),
  });

export const getAllBlogArticlesSlugs = async (locale = SUPPORTED_LOCALES.EN) =>
  blogApiCall({
    endpoint: `articles?sort[0]=createdAt%3Adesc&locale=${locale}&populate=category&fields=title,description,slug,createdAt&&pagination[pageSize]=1000`,
    method: 'GET',
    reshaper: (
      data: APIBlogResponse<{ id: number; attributes: BlogArticle }>
    ) => data.data.map((entry) => entry.attributes),
  });

export const getBlogArticle = async (slug: string, locale: string) => {
  return blogApiCall({
    endpoint: `articles?sort[0]=createdAt%3Adesc&filters[slug][$eq]=${slug}&populate=category,author,image,author.picture&locale=${locale}`,
    method: 'GET',
    reshaper: (
      data: APIBlogResponse<{ id: number; attributes: BlogArticle }>
    ) => {
      if (data.data.length === 0) {
        return null;
      }

      return data.data[0].attributes;
    },
  });
};

export const getDBBlogArticle = async ({
  slug,
  ...config
}: ApiCallConfig & { slug: string }) => {
  return apiCall({
    ...config,
    endpoint: `blog/articles/${slug}`,
    method: 'GET',
    reshaper: (data: BlogArticleMetadata) => data,
  });
};

export const updateDBBlogArticle = async (
  slug: string,
  article: BlogArticleMetadata
) => {
  return apiCall({
    endpoint: `blog/articles/${slug}`,
    method: 'PUT',
    body: article,
    reshaper: (data: BlogArticleMetadata) => data,
  });
};
